import Icon from './Icon';
import { ICONS } from '../lib/icons';

// The one place a modal is warranted: confirming a destructive action.
// Create/edit forms are rendered inline on the page, never in a popup.
export default function ConfirmDialog({
  title = 'Are you sure?',
  message,
  detail,
  confirmLabel = 'Delete',
  busy = false,
  error,
  onConfirm,
  onCancel,
}) {
  return (
    <div className="modal" role="dialog" aria-modal="true">
      <div className="modal__backdrop" onClick={busy ? undefined : onCancel} />
      <div className="modal__panel modal__panel--sm">
        <header className="modal__header">
          <h2>{title}</h2>
          <button
            className="icon-btn"
            onClick={onCancel}
            disabled={busy}
            aria-label="Close"
          >
            <Icon name={ICONS.close} />
          </button>
        </header>

        <div className="modal__body">
          {message ? <p>{message}</p> : null}
          {detail ? <p className="field__hint">{detail}</p> : null}
          {error ? <div className="form-error">{error}</div> : null}
        </div>

        <footer className="modal__footer">
          <button
            type="button"
            className="btn btn--ghost"
            onClick={onCancel}
            disabled={busy}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn--danger"
            onClick={onConfirm}
            disabled={busy}
          >
            {busy ? 'Working…' : confirmLabel}
          </button>
        </footer>
      </div>
    </div>
  );
}
